import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './HelpCenter.css';

const splitHeadingLetters = (text) =>
  text.split('').map((character, index) => (
    <span
      key={`${text}-${index}`}
      className={`help-center-heading-letter${character === ' ' ? ' is-space' : ''}`}
      style={{ '--letter-index': index }}
      aria-hidden="true"
    >
      {character === ' ' ? '\u00A0' : character}
    </span>
  ));

const HelpCenterPage = () => {
  const [isHeadingVisible, setIsHeadingVisible] = useState(false);

  useEffect(() => {
    const timer = window.setTimeout(() => {
      setIsHeadingVisible(true);
    }, 80);

    return () => {
      window.clearTimeout(timer);
    };
  }, []);

  return (
    <div className="help-center-page-wrapper">
      <div className="help-center-page-container help-center-page">
        <div className="help-center-back-link">
          <Link to="/">&larr; Back to Home</Link>
        </div>

        <div className="help-center-page-hero">
          <h1
            className={`help-center-heading ${isHeadingVisible ? 'is-visible' : ''}`}
            aria-label="Help Center"
          >
            {splitHeadingLetters('Help Center')}
          </h1>
          <p>
            Welcome to the BlackRoth Help Center. We're here to assist you with
            product guidance, technical support, and answers to common questions
            to ensure a smooth and reliable experience.
          </p>
        </div>

        <section className="help-center-page-section">
          <h2 className="help-center-section-heading">Getting Started</h2>
          <p>
            New to BlackRoth? Our onboarding resources help you set up your
            environment, configure services, and understand platform capabilities
            quickly. Step-by-step guides ensure your teams can begin leveraging
            our solutions with confidence.
          </p>
        </section>

        <section className="help-center-page-section">
          <h2 className="help-center-section-heading">Account &amp; Access Support</h2>
          <p>
            Manage user accounts, permissions, authentication settings, and
            organizational access controls. This section provides assistance on
            login issues, password recovery, and secure access management.
          </p>
        </section>

        <section className="help-center-page-section">
          <h2 className="help-center-section-heading">Technical Assistance</h2>
          <p>
            Encountering a technical issue? Explore troubleshooting documentation,
            system status updates, and integration support resources. Our support
            team is committed to resolving issues efficiently to minimize
            operational disruptions.
          </p>
        </section>

        <section className="help-center-page-section">
          <h2 className="help-center-section-heading">Contact &amp; Escalation</h2>
          <p>
            For critical concerns, enterprise clients can reach our dedicated
            support channels. We provide structured escalation pathways to ensure
            timely resolution aligned with service-level commitments.
          </p>
        </section>
      </div>
    </div>
  );
};

export default HelpCenterPage;
